import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/home/home-routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: 'candidates',
    loadChildren: () => import('./pages/Candidatess/candidate-routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: 'recruitment',
    loadChildren: () => import('./pages/Recruitment/recruitment-routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: 'man-power',
    loadChildren: () => import('./pages/ManPower/man-power-routes').then(m => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: 'forbidden',
    loadChildren: () => import('./pages/forbidden/forbidden.module').then(m => m.ForbiddenModule),
  },
];
